export interface NavLink {
  title: string;
  href: string;
  isNew?: boolean;
}

export interface NavPage {
  title: string;
  href?: string;
  items?: NavLink[];
  id?: string;
  isNew?: boolean;
}

export interface NavPages {
  main: NavPage[];
}

const pages: NavPages = {
  main: [
    {
      title: 'topbar.pages.products',
      href: '/products',
    },
    {
      title: 'topbar.pages.support.certificates',
      href: '/certificates',
    },
    {
      title: 'topbar.pages.support.whereToBuy',
      href: '/distributors',
    },
    {
      title: 'topbar.pages.company.contactUs',
      href: '/contact',
    },
    {
      title: 'topbar.pages.blog',
      href: '/blog',
    },
  ],
};

export default pages;
